import _extends from "@babel/runtime/helpers/esm/extends";
import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React from "react";
import PropTypes from "prop-types";
import Downshift from "downshift";

var MultiDownshift = /*#__PURE__*/function (_React$Component) {
  _inherits(MultiDownshift, _React$Component);

  var _super = _createSuper(MultiDownshift);

  function MultiDownshift() {
    var _this;

    _classCallCheck(this, MultiDownshift);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", {
      selectedItems: []
    });

    _defineProperty(_assertThisInitialized(_this), "stateReducer", function (state, changes) {
      switch (changes.type) {
        case Downshift.stateChangeTypes.keyDownEnter:
        case Downshift.stateChangeTypes.clickItem:
          return _objectSpread(_objectSpread({}, changes), {}, {
            highlightedIndex: state.highlightedIndex,
            isOpen: true
          });

        default:
          return changes;
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleSelection", function (selectedItem, downshift) {
      var callOnChange = function callOnChange() {
        var onChange = _this.props.onChange;
        var selectedItems = _this.state.selectedItems;

        if (onChange) {
          onChange(selectedItems, _this.getStateAndHelpers(downshift));
        }
      };

      if (_this.state.selectedItems.some(function (i) {
        return _this.clean(i) === _this.clean(selectedItem);
      })) {
        _this.removeItem(selectedItem, callOnChange);
      } else {
        _this.addSelectedItem(selectedItem, callOnChange);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "clean", function (item) {
      var itemToString = _this.props.itemToString;
      return itemToString ? itemToString(item) : item;
    });

    _defineProperty(_assertThisInitialized(_this), "removeItem", function (item, cb) {
      var onChange = _this.props.onChange;

      var callback = function callback() {
        var selectedItems = _this.state.selectedItems;

        if (cb) {
          cb();
          return;
        } // try to call onChange


        if (onChange) {
          onChange(selectedItems);
        }
      };

      _this.setState(function (_ref) {
        var selectedItems = _ref.selectedItems;
        return {
          selectedItems: selectedItems.filter(function (i) {
            return _this.clean(i) !== _this.clean(item);
          })
        };
      }, callback);
    });

    _defineProperty(_assertThisInitialized(_this), "getRemoveButtonProps", function () {
      var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var _onClick = _ref2.onClick,
          item = _ref2.item,
          props = _objectWithoutProperties(_ref2, ["onClick", "item"]);

      return _objectSpread({
        onClick: function onClick(e) {
          if (_onClick) {
            _onClick(e);
          }

          e.stopPropagation();

          _this.removeItem(item);
        }
      }, props);
    });

    return _this;
  }

  _createClass(MultiDownshift, [{
    key: "addSelectedItem",
    value: function addSelectedItem(item, cb) {
      this.setState(function (_ref3) {
        var selectedItems = _ref3.selectedItems;
        return {
          selectedItems: [].concat(_toConsumableArray(selectedItems), [item])
        };
      }, cb);
    }
  }, {
    key: "getStateAndHelpers",
    value: function getStateAndHelpers(downshift) {
      var selectedItems = this.state.selectedItems;
      var getRemoveButtonProps = this.getRemoveButtonProps,
          removeItem = this.removeItem;
      return _objectSpread({
        getRemoveButtonProps: getRemoveButtonProps,
        removeItem: removeItem,
        selectedItems: selectedItems
      }, downshift);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          render = _this$props.render,
          _this$props$children = _this$props.children,
          children = _this$props$children === void 0 ? render : _this$props$children,
          props = _objectWithoutProperties(_this$props, ["render", "children"]);

      var selectedItems = this.state.selectedItems;
      return /*#__PURE__*/React.createElement(Downshift, _extends({}, props, {
        stateReducer: this.stateReducer,
        onChange: this.handleSelection,
        selectedItem: selectedItems
      }), function (downshift) {
        return children(_this2.getStateAndHelpers(downshift));
      });
    }
  }]);

  return MultiDownshift;
}(React.Component);

MultiDownshift.displayName = "TagFilter.MultDownshift";
MultiDownshift.propTypes = {
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),
  itemToString: PropTypes.func.isRequired,
  onChange: PropTypes.func,
  render: PropTypes.func
};
export default MultiDownshift;